import firebase from 'firebase/app';
import 'firebase/auth';
import 'firebase/firestore';
import 'firebase/storage';
   
const firebaseConfig = {
    apiKey: "AIzaSyALeySI_5NbfQSmee2-eb8NtzASz_70n40",
    authDomain: "muhammadkamranlive.firebaseapp.com",
    projectId: "muhammadkamranlive",
    storageBucket: "muhammadkamranlive.appspot.com",
    messagingSenderId: "912484050414",
    appId: "1:912484050414:web:ce398a8ad6dd6c8e2e1aff",
    measurementId: "G-PL4PCH0CB5"
  };

class Firebase{
    constructor(){
        firebase.initializeApp(firebaseConfig);
        this.auth = firebase.auth();
        this.firestore=firebase.firestore();
    }

    async signin(email, password){
        const user = await firebase.auth().createUserWithEmailAndPassword(email, password).catch( err => {
            console.log(err);
            return err;
        });
        return user;
    }

    async login(email, password){
        const user = await firebase.auth().signInWithEmailAndPassword(email, password).catch( err => {
            console.log(err);
            return err;
        });
        return user;
    }

    async logout(){
        await firebase.auth().signOut().catch(err => {
            console.log(err);
        });
    }

    async getUserState(){
        return new Promise(resolve => {
            this.auth.onAuthStateChanged(resolve);
        });
    }


    async getPosts(){
        return await firebase.firestore().collection("posts").orderBy('timestamp', 'desc').get();
    }


    async getPost(postid){
        return await firebase.firestore().collection("posts").doc(postid).get();
    }


    async createPost(post){
       const storageRef = firebase.storage().ref();
       const storageChild = storageRef.child(post.cover.name);
       const postCover = await storageChild.put(post.cover);
       const downloadURL = await storageChild.getDownloadURL();
       const fileRef = postCover.ref.location.path;
       var today = new Date();
       var date = today.getFullYear()+'-'+(today.getMonth()+1)+'-'+today.getDate();
       let newPost = {
           title: post.title,
           content: post.content,
           date,
           timestamp: firebase.firestore.FieldValue.serverTimestamp(),
           cover: downloadURL,
           fileref: fileRef
       }

       await firebase.firestore().collection("posts").add(newPost);
       
       
    }



 async updatePost(postId, postData){
        if(postData["cover"]){
            const storageRef = firebase.storage().ref();
            const storageChild = storageRef.child(postData.cover.name);
            const postCover = await storageChild.put(postData.cover);
            const downloadURL = await storageChild.getDownloadURL();
            const fileRef = postCover.ref.location.path;

            await storageRef.child(postData["oldcover"]).delete().catch(err =>{
                console.log(err);
            });
            console.log("image deleted");

            var today = new Date();
            var date = today.getFullYear()+'-'+(today.getMonth()+1)+'-'+today.getDate();
            let updatedPost = {
                title: postData.title,
                content: postData.content,
                date,
                cover: downloadURL,
                fileref: fileRef
            }

            return await firebase.firestore().collection("posts").doc(postId).set(updatedPost, {merge: true});

        }else{
            return await firebase.firestore().collection("posts").doc(postId).set(postData, {merge: true});
        }
    }


    async deletePost(postId, fileRef){
        const storageRef = firebase.storage().ref();
        await storageRef.child(fileRef).delete().catch(err => {
            console.log(err);
        });

        return await firebase.firestore().collection("posts").doc(postId).delete();
    }

    async createContact(contact){
        let counter = {
            name: contact.name,
            Email: contact.Email,
            Message:contact.Message,
            datatime:contact.datatime
        }
 
        await firebase.firestore().collection("contact").add(counter);
        
        
     }


}

export default new Firebase();